<template>
  <SnackbarView :SnackbarComponent="SnackbarComponent" />
  <SuccessDialog :VuetifyObj="VuetifyObj" :dialog="successDialog" />
  <v-app-bar fixed class="bg">
    <v-row class="d-flex align-center justify-space-between">
      <v-col cols="6" md="4">
        <v-img
          class="ma-0 pa-0 text-start"
          width="200"
          src="@/assets/Kotler_and_levit_logo.png"
        />
      </v-col>
      <v-col cols="6" md="4">
        <h2
          class="form-title"
          :class="VuetifyObj.mdAndUp ? 'text-center' : 'text-end pe-2'"
        >
          {{ VuetifyObj.mdAndUp ? "Registration Form" : "Registration" }}
        </h2>
      </v-col>
      <v-col v-if="VuetifyObj.mdAndUp" cols="4">
        <div class="text-white font-weight-bold me-4 text-end">
          {{
            new Date().toLocaleDateString("en-GB", {
              weekday: "long",
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          }}
        </div>
      </v-col>
    </v-row>
  </v-app-bar>
  <v-app>
    <v-main>
      <v-container fluid class="pt-6 d-flex justify-center align-center">
        <v-card variant="elevated" elevation="12" class="register-card px-6">
          <v-form ref="ValidateForm" lazy-validation class="py-6">
            <v-row no-gutters>
              <!-- Profile Upload -->
              <v-col
                cols="5"
                md="3"
                class="d-flex align-center mb-4 justify-start"
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  id="ProfilePic"
                  @change="OnchangeMethod"
                />
                <label
                  v-if="!profilepic_url && !SelectedProfilePic"
                  for="ProfilePic"
                >
                  <v-avatar size="86" class="avatar-box me-4">
                    <v-img eager lazy-src :src="profilepic_url">
                      <template v-slot:placeholder>
                        <div
                          class="d-flex align-center justify-center fill-height"
                        >
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-icon>mdi-cloud-upload</v-icon>
                            </v-col>
                            <v-col cols="12">
                              <span class="text-caption"> Upload </span>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </v-img>
                  </v-avatar>
                </label>
                <v-avatar v-else size="86" class="avatar-box me-4">
                  <v-img eager lazy-src :src="profilepic_url">
                    <template v-slot:placeholder>
                      <div
                        class="d-flex align-center justify-center fill-height"
                      >
                        Profile
                      </div>
                    </template>
                  </v-img>
                </v-avatar>
                <v-fab
                  v-if="SelectedProfilePic"
                  icon="mdi-close"
                  color="red"
                  class="ml-n6 mb-n16"
                  size="24"
                  appear
                  @click="(SelectedProfilePic = null), (profilepic_url = '')"
                ></v-fab>
                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*"
                  class="d-none"
                  @change="handleFileUpload"
                />
              </v-col>
              <v-col cols="5" md="7" class="d-flex align-center">
                <div class="text-left mb-4">
                  <div class="text-body-2 font-weight-medium">
                    Profile Picture
                  </div>
                  <div class="mt-1 text-disabled" style="font-size: 0.75rem">
                    JPG or PNG
                  </div>
                  <div class="mt-1 text-disabled" style="font-size: 0.75rem">
                    Max Size (5MB)
                  </div>
                </div>
              </v-col>
              <v-col cols="2" class="text-end pt-4">
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      @click="$router.push('/')"
                      size="large"
                      >mdi-close-thick</v-icon
                    >
                  </template>
                  Cancel
                </v-tooltip>
              </v-col>

              <!-- Name -->
              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'pe-1' : ''">
                <v-text-field
                  v-model="signup.user_name"
                  label="Full Name"
                  prepend-inner-icon="mdi-account"
                  variant="outlined"
                  density="compact"
                  :rules="[(v) => !!v || 'Required']"
                />
              </v-col>

              <!-- Email -->
              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'ps-1' : ''">
                <v-text-field
                  v-model="signup.user_email_id"
                  label="Email Address"
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined"
                  density="compact"
                  type="email"
                  :rules="[
                    (v) => !!v || 'Required',
                    (v) =>
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                        v
                      ) || 'Email must be valid',
                  ]"
                />
              </v-col>

              <!-- Country Code + Mobile -->
              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'pe-1' : ''">
                <v-autocomplete
                  v-model="signup.country_code"
                  :items="CountryCodeItems"
                  item-value="dial_code"
                  item-title="name"
                  label="Country"
                  prepend-inner-icon="mdi-flag-variant-outline"
                  variant="outlined"
                  density="compact"
                  :rules="[(v) => !!v || 'Required']"
                >
                  <template v-slot:item="{ props, item }">
                    <div class="FontSize12px mx-2" v-bind="props">
                      {{ item.raw.name }}- ({{ item.raw.dial_code }})
                    </div>
                  </template>
                  <template v-slot:selection="{ item }">
                    <div class="FontSize12px mx-2">
                      {{ item.raw.dial_code }}
                    </div>
                  </template>
                  <template v-slot:label>
                    <div class="FontSize12px">Country Code*</div>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'ps-1' : ''">
                <v-text-field
                  v-model="signup.user_mobile_number"
                  label="Mobile Number"
                  prepend-inner-icon="mdi-phone"
                  variant="outlined"
                  density="compact"
                  type="number"
                  :rules="[
                    (v) =>
                      /^(?=[a-zA-Z0-9@#._%+-]{0,30}$)[-0-9]{0,64}$/.test(v) ||
                      'Numeric only',
                    (v) => (v && v.length > 9) || 'Minimum 10 Digits',
                    (v) => (v && v.length < 11) || 'Maximum 10 Digits',
                  ]"
                />
              </v-col>

              <!-- Address -->
              <v-col cols="12">
                <v-textarea
                  v-model="signup.user_address"
                  label="Address"
                  prepend-inner-icon="mdi-map-marker-outline"
                  variant="outlined"
                  density="compact"
                  rows="2"
                  :rules="[(value) => !!value || 'required']"
                />
              </v-col>

              <!-- City + Age -->
              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'pe-1' : ''">
                <v-text-field
                  v-model="signup.user_city"
                  label="City"
                  prepend-inner-icon="mdi-city"
                  variant="outlined"
                  density="compact"
                  :rules="[(value) => !!value || 'required']"
                />
              </v-col>

              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'ps-1' : ''">
                <v-text-field
                  v-model="signup.user_age"
                  label="Age"
                  prepend-inner-icon="mdi-calendar-account"
                  type="number"
                  :rules="[
                    (v) =>
                      /^(?=[a-zA-Z0-9@#._%+-]{0,30}$)[-0-9]{0,64}$/.test(v) ||
                      'Numeric only',
                    (value) => !!value || 'required',
                    (value) => value > 0 || 'Age cannot be negative',
                    (value) => value < 100 || 'Age seems invalid',
                  ]"
                  variant="outlined"
                  density="compact"
                />
              </v-col>

              <!-- Qualification + Experience -->
              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'pe-1' : ''">
                <v-select
                  v-model="signup.user_qualification"
                  :items="qualifications"
                  label="Qualification"
                  prepend-inner-icon="mdi-school-outline"
                  variant="outlined"
                  density="compact"
                  :rules="[(value) => !!value || 'required']"
                />
              </v-col>

              <v-col cols="12" md="6" :class="VuetifyObj.mdAndUp ? 'ps-1' : ''">
                <v-select
                  v-model="signup.user_experience"
                  :items="experienceList"
                  label="Experience (Years)"
                  prepend-inner-icon="mdi-briefcase-outline"
                  variant="outlined"
                  density="compact"
                  :rules="[(value) => !!value || 'required']"
                />
              </v-col>

              <v-col cols="12" class="mb-2">
                <v-checkbox
                  v-model="signup.consent"
                  density="compact"
                  color="primary"
                  hide-details="auto"
                  class="ma-0 pa-0"
                  :rules="[(v) => !!v || 'You must accept the terms']"
                >
                  <template #label>
                    <span class="text-caption" style="line-height: 1.1">
                      I have read and understood the
                      <v-btn
                        size="v-small"
                        variant="text"
                        color="primary"
                        class="text-capitalize"
                        @click="termsDialog = true"
                        >Terms</v-btn
                      >, and I accept all terms and conditions of Kotler &
                      Levitt, including any changes made from time to time.
                    </span>
                  </template>
                </v-checkbox>
              </v-col>

              <!-- Button -->
              <v-col cols="12">
                <v-btn
                  class="register-btn"
                  block
                  height="46"
                  :disabled="!signup.consent"
                  :loading="buttonLoader"
                  @click="ValidateMethod()"
                >
                  Register Now
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-dialog
            v-model="termsDialog"
            max-width="650px"
            persistent
            scrollable
          >
            <v-card class="pa-4 rounded-lg">
              <v-card-title class="text-h6 font-weight-bold">
                Terms And Conditions
              </v-card-title>

              <v-card-text class="text-body-2" style="line-height: 1.4">
                <p>
                  This web-based mock test platform is intended only for
                  practice and self-assessment, and it is not an official
                  examination.
                </p>
                <p>
                  All efforts are made to ensure accuracy in questions, options,
                  and answers; however, errors or omissions may still occur.
                </p>
                <p>
                  If you find any incorrect information, please notify us so it
                  can be corrected in future updates.
                </p>

                <p>
                  The platform may experience technical issues, downtime, or
                  system glitches.
                </p>
                <p>
                  In such situations, the scheduled test for the day may be
                  postponed, and services will resume after problems are fully
                  resolved.
                </p>
                <p>
                  Although we aim to provide one mock test every day at a
                  scheduled time, there is no guarantee of a minimum number of
                  tests, as availability depends on operational and technical
                  factors.
                </p>

                <p>
                  Fees paid for accessing the mock tests are non-refundable
                  under any circumstances.
                </p>
                <p>
                  Users must ensure that their login credentials are kept
                  confidential and not shared with any other person. Any misuse
                  or unauthorized access resulting from sharing credentials will
                  be the responsibility of the user.
                </p>

                <p>
                  After completing each test, participants will be able to view
                  all correct answers for review and learning.
                </p>
                <p>
                  Users are advised to maintain stable internet connectivity and
                  proper device settings, as interruptions on the user's side
                  are beyond the platform’s control.
                </p>
              </v-card-text>

              <v-card-actions class="d-flex justify-end">
                <v-btn
                  color="success"
                  variant="flat"
                  @click="(termsDialog = false), (consent = true)"
                >
                  I Acknowledge
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
/* Card */
.bg {
  background: linear-gradient(90deg, #30b8b8, #103e90) !important;
}
.register-card {
  max-width: 520px;
  width: 100%;
  border-radius: 18px;
  background: #ffffff;
}

/* Logo */
.logo-img {
  width: 74px;
}

/* Titles */
.form-title {
  font-weight: 700;
  color: rgb(2, 39, 108);
}
.form-subtitle {
  margin-top: 2px;
  color: #7a869a;
  font-size: 0.85rem;
}

/* Avatar */
.avatar-box {
  border: 3px dotted rgba(5, 146, 146, 0.25);
  background: #ffffff;
}

/* Button */
.register-btn {
  background: linear-gradient(90deg, #103e90, #30b8b8);
  color: white !important;
  font-weight: 600;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(16, 62, 144, 0.2);
}

/* Mobile optimization */
@media (max-width: 600px) {
  .register-card {
    padding: 18px !important;
  }
  .logo-img {
    width: 56px;
  }
}
</style>

<script>
import { useDisplay } from "vuetify";
import CountryCodeList from "@/JsonFiles/CountryCodeList.json";
import axios from "axios";
import SnackbarView from "@/components/SnackbarView.vue";
import SuccessDialog from "@/components/SuccessDialog.vue";
import moment from "moment-timezone";

export default {
  data: () => ({
    successDialog: false,
    buttonLoader: false,
    termsDialog: false,
    consent: false,
    SelectedProfilePic: null,
    profilepic_url: "",
    current_view: "",
    QuizDetails: {},
    VuetifyObj: {},
    SnackbarComponent: {},
    CountryCodeItems: [],
    signup: {
      user_name: "",
      user_email_id: "",
      user_mobile_number: "",
      country_code: "",
      user_address: "",
      user_city: "",
      consent: false,
      user_age: null,
      user_qualification: "",
      user_experience: "",
      profile_s3_key: "",
    },
    qualifications: ["Graduate", "Postgraduate", "Diploma"],
    experienceList: ["Fresher", "1-2 Years", "3-5 Years", "5+ Years"],
  }),
  components: {
    SnackbarView,
    SuccessDialog,
  },
  async mounted() {
    this.VuetifyObj = useDisplay();
    this.CountryCodeItems = CountryCodeList;
  },
  watch: {
    "signup.consent"(val) {
      if (val) {
        if (!this.consent) {
          this.SnackbarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            SnackbarText: "Read the terms before accepting",
          };
          this.signup.consent = false;
        }
      }
    },
    consent(val) {
      if (val) {
        this.signup.consent = true;
      }
    },
  },
  methods: {
    GetConvertedDate(quiz_date) {
      const [yyyy, mm, dd] = quiz_date.split("-");
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthAbbreviation = months[parseInt(mm, 10) - 1];
      const year = yyyy.slice(2);
      return `${dd}-${monthAbbreviation}-${year}`;
    },
    convertTo12Hour(time) {
      let [hours, minutes] = time.split(":").map(Number);
      const period = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      const date = moment.tz(`${hours}:${minutes}`, "HH:mm", moment.tz.guess());
      const timezoneAbbreviation = date.format("z");

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )} ${period} ${timezoneAbbreviation}`;
    },
    async OnchangeMethod(event) {
      this.SelectedProfilePic = event.target.files[0];
      if (this.SelectedProfilePic) {
        this.profilepic_url = URL.createObjectURL(this.SelectedProfilePic);
        await this.uploadImage();
      }
    },
    async httpsUploadMethod(presignedUrl, file) {
      try {
        const response = await axios.put(presignedUrl, file);
        console.log("Response : ", response);
        if (response.status == 200 && response.statusText == "OK") {
          this.SnackbarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "success",
            SnackbarText: "Image uploaded Successfully",
          };
          return "Success";
        } else {
          this.SnackbarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            SnackbarText: response.statusText,
          };
          return "Failure";
        }
      } catch (error) {
        console.log(error);
      }
    },
    async uploadImage() {
      this.signup.profile_s3_key = `PROFILE_PIC/${Date.now()}_${
        this.SelectedProfilePic.name
      }`;
      try {
        let data = {
          command: "presignedUrl",
          key: this.signup.profile_s3_key,
        };
        let config = {
          method: "post",
          url: "https://hwfdmjv1vj.execute-api.ap-south-1.amazonaws.com/production/presigned_url",
          data: data,
        };
        let result = await axios(config);
        if (result.data.status === "SUCCESS") {
          const url = result.data.url;
          await this.httpsUploadMethod(url, this.SelectedProfilePic);
        }
      } catch (error) {
        console.log("error : ", error);
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          SnackbarText: error,
        };
      }
    },
    async ValidateMethod() {
      try {
        const { valid } = await this.$refs.ValidateForm.validate();
        if (valid) {
          this.buttonLoader = true;
          let data = {
            command: "createUserFromRegistrationForm",
            ...this.signup,
          };
          let config = {
            method: "post",
            headers: {},
            url: "https://hwfdmjv1vj.execute-api.ap-south-1.amazonaws.com/production/signup_user",
            data: data,
          };
          let result = await axios(config);
          if (result.data.status === "SUCCESS") {
            this.successDialog = true;
          }
        } else {
          this.SnackbarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            SnackbarText: `Please fill mandatory fields`,
          };
        }
      } catch (error) {
        this.buttonLoader = false;
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          SnackbarText: error,
        };
      }
    },
    successDialogEmit() {
      this.successDialog = false;
    },
  },
};
</script>
